/**
 * 前台货币符号映射与价格格式化（统一入口）
 *
 * 取值对齐后端 OWProductPriceUnit 领域枚举（25 种在售国家币种代码，RMB=人民币），
 * 另附 USD（美元）映射。后端枚举后续新增币种时需同步在此补充。
 * 未在表中出现的单位回退为直接显示单位代码本身。
 */
export const CURRENCY_SYMBOLS = {
	RMB: '¥', // 人民币 CNY
	USD: '$', // 美元
	MMK: 'K', // 缅甸元
	SGD: 'S$', // 新加坡元
	INR: '₹', // 印度卢比
	THB: '฿', // 泰铢
	VND: '₫', // 越南盾
	LAK: '₭', // 老挝基普
	ZAR: 'R', // 南非兰特
	NGN: '₦', // 尼日利亚奈拉
	EGP: 'E£', // 埃及镑
	KES: 'KSh', // 肯尼亚先令
	MAD: 'DH', // 摩洛哥迪拉姆
	GHS: 'GH₵', // 加纳塞地
	ETB: 'Br', // 埃塞俄比亚比尔
	TND: 'DT', // 突尼斯第纳尔
	TZS: 'TSh', // 坦桑尼亚先令
	RWF: 'FRw', // 卢旺达法郎
	BRL: 'R$', // 巴西雷亚尔
	MXN: 'MX$', // 墨西哥比索
	ARS: 'AR$', // 阿根廷比索
	COP: 'COP$', // 哥伦比亚比索
	VES: 'Bs.', // 委内瑞拉玻利瓦尔
	GTQ: 'Q', // 危地马拉格查尔
	EUR: '€', // 欧元
	NZD: 'NZ$', // 新西兰元
};

/**
 * 格式化金额：货币符号在前 + 千分位
 * @param {number|string|null|undefined} price 金额
 * @param {string} [unit] 价格单位代码，默认 RMB
 * @returns {string} 格式化后的金额字符串或 ''
 */
export function formatPrice(price, unit = 'RMB') {
	if (price === undefined || price === null) return '';
	const symbol = CURRENCY_SYMBOLS[unit] || unit;
	return `${symbol}${Number(price).toLocaleString()}`;
}
